export const GoogleMapApiConfig = 'AIzaSyDczIYArMydC7WA3wxjFTv2hgPhjIOCN8w';